import React from 'react';
import '../styles/pages/home.scss';
import { Container, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import downloadapp from '../assets/download-app.svg';
import googleplaystore from '../assets/icons/googleplaystore.svg';
import applestore from '../assets/icons/applestore.svg';

const Downloadapp = () => {
    return (
        <React.Fragment>
            <section className="downloadapp-section">
                <div className='downloadapp-title'>
                    <Typography variant='h3'>Download our app</Typography>
                </div>
                <Typography className='download-subheading' variant='h6'>Experience Our Premium Services at Your Doorstep with Our App</Typography>

                <Container maxWidth="lg">
                    <div className='downloadapp'>
                        <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                                <div className='downloadapp-content'>
                                    <Typography variant='h4'>You can now customize your clothes online with <span>Tailors4U</span> mobile app
                                    </Typography>
                                    <Typography >Tailors4U mobile app makes it easy to customize your clothes online. You can choose fabrics, designs, and enter your measurements for a perfect fit. The app also lets you get expert advice through video or in-person consultations. It’s a simple way to get tailor-made outfits without leaving home.</Typography>
                                    {/* <Typography variant='h5'>Mobile App Available on Play store and IOS App store</Typography> */}
                                    <div className='downloadapp-link'>
                                        <a href="https://play.google.com/store/apps/details?id=com.tailor4u.user&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">
                                            <img src={googleplaystore} alt='Download on Google Play Store' />
                                        </a>
                                        {/* <a href="https://play.google.com/store/apps/details?id=com.tailor4u.user&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">
                                            <img src={googleplaystore} alt='Download on Google Play Store' />
                                        </a> */}
                                        <a href="https://apps.apple.com/in/app/tailors4u/id6758755806" target="_blank" rel="noopener noreferrer" >
                                            <img src={applestore} alt='Download on Apple Store' />
                                        </a>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                                <div className='downloadapp-image'>
                                    <img src={downloadapp} alt='downloadapp' />
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </Container>
            </section>
        </React.Fragment>
    )
}

export default Downloadapp